const min = Math.min;
const max = Math.max;

/**
 * Axis aligned bounding box
 */
class AABB
{
    /**
     * Construct a new ABB
     *
     * @param x0    {number?} minimal x
     * @param y0    {number?} maximal x
     * @param x1    {number?} minimal y
     * @param y1    {number?} maximal y;
     */
    constructor(x0,y0,x1,y1)
    {
        this.reset();

        if (x0 !== undefined)
        {
            this.extend(x0,y0);
            this.extend(x1,y1);
        }
    }

    /**
     * Resets the min/max values to +/- Infinity
     */
    reset()
    {
        this.minX = Infinity;
        this.minY = Infinity;
        this.maxX = -Infinity;
        this.maxY = -Infinity;
    }

    /**
     * Extends this AABB with a coordinate or another AABB
     *
     * @param x {number|AABB} x coordinate or AABB value
     * @param y {?number}   y coordinate, will be ignored if first value is AABB
     */
    extend(x,y)
    {
        if (x instanceof AABB)
        {
            this.extend(x.minX, x.minY);
            this.extend(x.maxX, x.maxY);
        }
        else
        {
            this.minX = min(this.minX, x);
            this.minY = min(this.minY, y);
            this.maxX = max(this.maxX, x);
            this.maxY = max(this.maxY, y);
        }
    }
}

export default AABB



// WEBPACK FOOTER //
// ./src/util/aabb.js